import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap, takeUntil } from 'rxjs/operators';

@Injectable()
export class WasteCategoryService {
    constructor(private http: HttpClient) { }
    fetchSection() {
        return this.http.get(environment.apiURL + 'section/list').pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
    
    createSection(data) {
        return this.http.post(environment.apiURL + 'section/create', data).pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
    updateSection(data) {
        return this.http.post(environment.apiURL + 'section/update', data).pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
    deleteType(id) {
        return this.http.delete(environment.apiURL + 'wastetype/delete/' + id).pipe(
            tap((response: any) => {
                return response;
            })
        );
    }

    wasteTypeList() {
        return this.http.get(environment.apiURL + 'wastetype/list').pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
    EWCCategoryList() {
        return this.http.get(environment.apiURL + 'waste-category/list-waste-category').pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
    getWasteTypeDetails(id) {
        return this.http.get(environment.apiURL + 'wastetype/' + id).pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
    createWasteType(data) {
        return this.http.post(environment.apiURL + 'wastetype/create', data).pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
    parentWasteTypes(data){
        console.log('data',data);
        return this.http.post(environment.apiURL + 'waste-category/list-parent-waste-category',data).pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
    subCategoryList(data){
        return this.http.post(environment.apiURL + 'waste-category/list-sub-waste-category',data).pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
    updateWasteType(data) {
        return this.http.post(environment.apiURL + 'wastetype/update', data).pipe(
            tap((response: any) => {
                return response;
            })
        );
    }















    uploadFiles(data) {
        return this.http.post(environment.apiURL + 'student/upload', data).pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
    companyList() {
        return this.http.get(environment.apiURL + 'company/list').pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
    typeList() {
        return this.http.get(environment.apiURL + 'shared/list-disposal-types').pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
    
    /* fetchDisposalLocation() {
        return this.http.get(environment.apiURL + 'disposallocation/list').pipe(
            tap((response: any) => {
                return response;
            })
        );
    } */
    fetchDisposalLocation(data?: any) {
        if (!data || data == undefined || data == null) {
            data = {}
        }
        return this.http.post(environment.apiURL + 'disposallocation/list', data).pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
    fetchParentWasteTypes(){
        let val;
        return this.http.post(environment.apiURL + 'disposallocation/list', val).pipe(
            tap((response: any) => {
                return response;
            })
        ); 
    }
    createDisposalLocation(data) {
        return this.http.post(environment.apiURL + 'disposallocation/create', data).pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
    departmentList(value) {
        return this.http.get(environment.apiURL + 'department/list?companyId=' + value).pipe(
            tap((response: any) => {
                return response;
            })
        );

    }

    getDisposalDetails(id) {
        return this.http.get(environment.apiURL + 'disposallocation/' + id).pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
    updateDisposalLocation(data) {
        return this.http.post(environment.apiURL + 'disposallocation/update', data).pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
    deleteStudent(id) {
        return this.http.delete(environment.apiURL + 'student/delete/' + id).pipe(
            tap((response: any) => {
                return response;
            })
        );
    }



    // updateUser(data): Observable<any> {
    //     return this.http.post(environment.apiURL + 'user/update', data).pipe(
    //         tap((res: any) => {
    //             return res;
    //         })
    //     );
    // }
    create(registerForm) {
        return this.http.post(environment.apiURL + 'user/create', registerForm).pipe(tap((res) => res));
    }
    // fetchUser() {
    //     return this.http.get(environment.apiURL + 'user/list').pipe(tap((res) => res));
    // }
    deleteSite(id) {
        return this.http.delete(environment.apiURL + 'disposallocation/delete/' + id).pipe(tap((res) => res));
    }
    deleteParentWasteType(id){
        return this.http.delete(environment.apiURL + 'disposallocation/delete/' + id).pipe(tap((res) => res));
    }
}
